module.exports = __webpack_public_path__ + "static/android-chrome-512x512-6c92f923ee9c3762b525167de4e9aa37.png";